import styled, { spacing } from "@rentiohq/web-theme";

export const Label = styled.span`
  display: inline-block;
  padding: 2px ${spacing("tight")};
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.getColor("primary", "200")};
  background: ${({ theme }) => theme.colors.neutral0};
  color: ${({ theme }) => theme.getColor("primary", "1000")};
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
`;
